import { REGEX } from '@/data/constants/regex';

export const isNumeric = (input: string) => {
	const NUMERIC = REGEX.NUMERIC;
	return NUMERIC.test(input);
};
